import { render, staticRenderFns } from "./WeixinList.vue?vue&type=template&id=242cecb2&scoped=true"
import script from "./WeixinList.vue?vue&type=script&lang=js"
export * from "./WeixinList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242cecb2",
  null
  
)

export default component.exports